


















// Shows an email field with submit button.
// Upon enter or submit, we send email to /api/auth/emailOnlySignup.
// If error then show error.
// If user is returned,
//  * show popup that tells user that someone will reach out to them by email -or-
//  * tell them that if they want to get a head start and register on their own, they can by clicking 
// Replace email input field with a Confirmation thank you message

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StoryUser } from '../StoryUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';

@Component({
  name: 'SignupWhiteGloveBox',
  components: {
  }
})
export default class SignupWhiteGloveBox extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public whiteGloveSignUpHeader: string = null
  public buttonCTA: string = null
  public email: string = null;
  public signedUp: boolean = false

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get emailPlaceholder(): string { return "your email address" }


  public async onOK() {
    // validate form fields
    let abort: boolean = false
    if (!this.email || this.email.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter an email address.')
    }
    if (this.email && !utils.isValidEmail(this.email)) {
      abort = true
      utils.toast(this, 'Invalid email', 'Please enter a valid email address.')
    }
    if (abort) return

    // get utm parameters in case we have them captured by App, Home, HomeAnonymous, Blog or Lander.vue
    const utm_source: string = localStorage.getItem('utm_source')
    const utm_campaign: string = localStorage.getItem('utm_campaign')
    const utm_medium: string = localStorage.getItem('utm_medium')
    const utm_content: string = localStorage.getItem('utm_content')
    const utm_term: string = localStorage.getItem('utm_term')

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/auth/emailOnlySignup'
      const response: any = await utils.makePostCall(url, { email: this.email, utm_source, utm_campaign, utm_medium, utm_content, utm_term } );
      if (!response || !response.data) throw(new Error('SignupWhiteGloveBox.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user) {
        // success

        const user: StoryUser = new StoryUser(response.data.user);
        (window as any).analytics.alias(user.getIdAsString());  // tie the previously anon user to this newly id'd user

        (window as any).analytics.track('User Signed Up White Glove')

        this.signedUp = true

        // TODO: show modal that gives tells them that a specialist will reach out to them,
        // but that if they want a head start, they can click ____ to register now


      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not sign up')
      if (this.$store.state.devmode) console.error(error);
    }

    this.$store.commit('setLoading', { loading: false });

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private created() {
    const whiteGloveSignUpHeaders: string[] = [
      'Want to learn more? Enter your email and a specialist will get back to you.',
      'Want to learn more? Enter your email below.',
      'Reserve your spot below and a specialist will contact you.',
      'Join our waitlist by entering your email below.'
    ]
    const buttonCTAs: string[] = [
      'Submit',
      'Submit',
      'Save me a spot',
      'Join waitlist'
    ]
    const r: number = Math.floor(Math.random() * whiteGloveSignUpHeaders.length)
    this.whiteGloveSignUpHeader = whiteGloveSignUpHeaders[r]
    this.buttonCTA = buttonCTAs[r];

    // for funnel conversion tracking
    (window as any).analytics.track('SignupWhiteGloveBox Viewed', { whiteGloveSignUpHeader: this.whiteGloveSignUpHeader, buttonCTA: this.buttonCTA });
  }

  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
